import { Controller } from "@hotwired/stimulus"

// Erkennt die Browser-Zeitzone (IANA, z.B. "Europe/Berlin") ueber die
// Intl-API und:
// - fuellt bei der Registrierung das versteckte timezone-Feld automatisch
//   mit dem passenden ActiveSupport::TimeZone-Kurznamen (z.B. "Berlin"),
//   statt beim hartkodierten Default ("Berlin", siehe Migration
//   20260720080000) zu bleiben, egal wo der Account tatsaechlich sitzt.
// - haelt bei bereits eingeloggten Usern die gespeicherte Zeitzone im
//   Hintergrund synchron (z.B. nach einem Zeitzonenwechsel durchs Reisen),
//   ohne dass manuell im Profil nachgepflegt werden muss.
//
// Das IANA->Rails-Mapping kommt server-seitig aus
// ActiveSupport::TimeZone::MAPPING (siehe ApplicationController#
// timezone_iana_to_rails_map), damit es nicht dupliziert in JS gepflegt
// werden muss.
export default class extends Controller {
  static targets = ["input"]
  static values = { map: Object, current: String, updateUrl: String }

  connect() {
    let iana
    try {
      iana = Intl.DateTimeFormat().resolvedOptions().timeZone
    } catch {
      return
    }

    const railsName = this.mapValue[iana]
    if (!railsName) return

    if (this.hasInputTarget) {
      this.inputTarget.value = railsName
    }

    if (this.updateUrlValue && railsName !== this.currentValue) {
      this.sync(railsName)
    }
  }

  sync(railsName) {
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.updateUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token
      },
      body: JSON.stringify({ timezone: railsName })
    })
  }
}
